export default __webpack_public_path__ + "8ec0fa163f1ae9f364160a304fadb2a1.png";